import { useEffect, useRef } from "react";
import { API_URL } from "../utils/constants";

export function useReconciliationSSE({ fileType, fileReconId, fileStatus, onUpdate } : { fileType: any, fileReconId: any, fileStatus: any, onUpdate: any }) {
  const eventSourceRef = useRef<EventSource | null>(null);

  useEffect(() => {
    if (fileStatus === "COMPLETED") return;
    if (!fileType || !fileReconId) return;

    const url = `${API_URL}/api/sse/subscribe/recon-${fileType}-${fileReconId}`;
    const eventSource = new window.EventSource(url);
    eventSourceRef.current = eventSource;

    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event?.data);
        onUpdate(data);
      } catch {
        onUpdate(event?.data);
      }
    };

    eventSource.onerror = () => {
      eventSource.close();
    };

    return () => {
      eventSource.close();
    };
  }, [fileType, fileReconId, fileStatus, onUpdate]);
}
